const PAGE_LOAD_URL = '/page/data/load';

const API_PAGE_NAME = 'apiPage';

export {
  PAGE_LOAD_URL,

  API_PAGE_NAME,
};
